import springApi from '../../services/springApi'

export const storeDownloadToken = data => (
	new Promise((resolve, reject) => {
		springApi()
			.post('/download_tokens', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)